export default __webpack_public_path__ + "static/media/Group 1884.616a387b.png";